import { render, staticRenderFns } from "./PMChartInfo.vue?vue&type=template&id=0211a5d4&"
import script from "./PMChartInfo.vue?vue&type=script&lang=ts&"
export * from "./PMChartInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PMChartInfo.vue?vue&type=style&index=0&id=0211a5d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports